import React, {Component} from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import Heroimage from '../components/Heroimage'
import Blueitems from '../components/Blueitems'
import VettrisHeader from '../components/VettrisHeader'
import Colors from '../utils/colors'
import Breakpoints from '../utils/breakpoints'
import {prettifyUrl, getLang} from "../utils/util-functions";
import contentfulData from '../../contentfuldata/data.json';
import Radium from 'radium';
import {StyleRoot} from 'radium';
import MapComponent from '../components/MapComponent';
import NewsLetter from '../components/NewsLetter';
import VettrisFooter from '../components/VettrisFooter';
import ArticleImageWithText from '../components/ArticleImageWithText';
import ArticleHighlight from '../components/ArticleHighlight';
import marked from 'marked';
import _ from 'lodash';
import TagManager from 'react-gtm-module';


export class IndexPage extends Component {

  changeUrl (article){
    this.props.history.push('/guides/#article='+article);
  }

  componentDidMount(){
    const tagManagerArgs = {
      gtmId: 'GTM-NQXVHS7'
    };
    TagManager.initialize(tagManagerArgs);

    setTimeout(() => { document.body.scrollTop = 0;}, 2);
  }

  render (){
    const brand = getLang();
    const items = contentfulData.servicesData[brand].services;
    const title = contentfulData.singleData[brand].singleData.frontpageItemHeader;
    const secondTitle = contentfulData.singleData[brand].singleData.frontpageSecondTitle;
    const paragraph = contentfulData.singleData[brand].singleData.frontpagelongtext;
    const mapTitle = contentfulData.singleData[brand].singleData.frontpageMapTitle;
    const mapItems = contentfulData.clinicsData[brand].clinicsData;
    const heroText = contentfulData.singleData[brand].singleData.frontpageHeroText;
    const heroImage = contentfulData.singleData[brand].singleData.frontpageHeroImage.fields.file ? contentfulData.singleData[brand].singleData.frontpageHeroImage.fields.file.url : "";
    const emailText = contentfulData.singleData[brand].singleData.frontpageEmailText;
    const guides = contentfulData.guideArticlesData[brand].guideArticlesData;
    const currenNewstTitle = contentfulData.singleData[brand].singleData.frontpageWidgetTitle;

    marked.setOptions({
      breaks: true
    });

    return (
        <div>
          <VettrisHeader history={this.props.history}/>
          <Heroimage url={heroImage} heroText={heroText}/>
          <div className="col-xs-12 hidden-sm hidden-md hidden-lg" style={styles.heroText}>
            <div className="mobileHeroText" dangerouslySetInnerHTML={ {__html: marked(heroText)} }></div>
          </div>
          <StyleRoot>
            <div style={{marginTop: Breakpoints.componentDivider}}></div>
            <div style={styles}>
                 <div className="col-xs-12 col-md-8">
                  <h3 style={{marginTop: 16, fontFamily: 'Merriweather'}}>{title}</h3>
                   <div className="row"> <Blueitems items={items} history={this.props.history}/></div>
                  <div className="clearfix"></div>
                   <div style={styles.responsiveDivider} ></div>
                  <h3 style={{marginTop: Breakpoints.componentDivider, fontFamily: 'Merriweather'}}>{secondTitle}</h3>
                  <p>{paragraph}</p>
                  <div className="clearfix" style={{marginTop: Breakpoints.componentDivider}}></div>
                  <div className="row">
                    {  _.sortBy(guides.filter(g => g.articleHighlight), [guide => guide.articleImage])
                        .map((guide, a) => {
                              if (guide.articleImage)
                                return <div style={styles.singleArticleLink} onClick={() => this.changeUrl(prettifyUrl(guide.articleHeadline))} className="col-xs-12" key={a}><div style={styles.dividerSingleItem}><ArticleImageWithText key={a} twoPanels={true} title={currenNewstTitle} headline={guide.articleHeadline} image={guide.articleImage.fields.file.url} /></div></div>
                              if (guide.articleHighlight)
                                return <div style={styles.singleArticleLink} onClick={() => this.changeUrl(prettifyUrl(guide.articleHeadline))} className="col-xs-12 col-md-6" key={a}><div style={styles.dividerSingleItem}><ArticleHighlight key={a} headline={guide.articleHeadline} /></div></div>
                              return <div style={styles.singleArticleLink} onClick={() => this.changeUrl(prettifyUrl(guide.articleHeadline))} className="col-xs-12 col-md-6" key={a}><div style={styles.dividerSingleItem}>{guide.articleHeadline}</div></div>
                            }
                    )}
                  </div>
                </div>
                <div className="col-md-4 col-xs-12" style={styles.firstRow} >
                  <div style={{marginTop: 10}}>
                    <MapComponent items={mapItems} title={mapTitle} history={this.props.history}/>
                  </div>
                </div>
                <div className="clearfix"></div>
              <div className="row">
                <div className="col-xs-12">
                  <div className="col-xs-12">
                    <NewsLetter text={emailText} />
                  </div>
                </div>
              </div>
              <div style={{marginTop: Breakpoints.componentDivider}}></div>
            </div>
          </StyleRoot>
          <VettrisFooter />
        </div>
    )
  }

}

export default Radium(IndexPage)

const styles = {
  width: '100%',
  margin: '0 auto',
  [Breakpoints.media.siteOverMaxWidth]: {
    width: Breakpoints.width.site
  },
  firstRow: {
    marginTop: Breakpoints.componentDivider
  },
  divider: {
    marginTop: 20
  },
  singleArticleLink: {
    textDecoration: 'none',
    color: Colors.darkBlue,
    ':hover': {
      cursor: 'pointer'
    }
  },
  dividerSingleItem: {
    paddingBottom: 30,
    [Breakpoints.media.siteUnderMaxWidth]: {
      marginTop: 0,
      paddingTop: 0,
      paddingBottom: 20,
    },
  },
  responsiveDivider: {
    marginTop: Breakpoints.componentDivider,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: Breakpoints.mobileDivider
    }
  },
  heroText: {
    marginTop: 20,
    marginBottom: 40,
  }
};


// WEBPACK FOOTER //
// ./src/pages/index.js